import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import FavoriteSuggestion from '../../types/FavoriteSuggestion';
import FavoriteSuggestionType from '../../types/FavoriteSuggestionType';
import { isFolderInFavorites } from 'owa-favorites';
import { MoveToFolderType } from 'owa-mail-moveto-control';
import { lazyGetFoldersForMoveTo } from 'owa-mail-moveto-control';

export default async function getFavoriteFolderSuggestions(
    findText: string
): Promise<FavoriteSuggestion[]> {
    const maxFolderSuggestions = getMaxFavoriteSuggestionCounts().folder;

    //Find top matching folders not already in favorites
    const getFoldersForMoveTo = await lazyGetFoldersForMoveTo.import();

    const folders = getFoldersForMoveTo(
        'primary',
        0 /* depth */,
        findText,
        maxFolderSuggestions,
        folderId => !isFolderInFavorites(folderId)
    ).folders; /* customFilter */

    const items: FavoriteSuggestion[] = folders.map((folder: MoveToFolderType) => {
        const folderDisplayName = folder.displayName;

        return {
            id: folder.folderId,
            data: folderDisplayName,
            type: FavoriteSuggestionType.Folder,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });

    return items;
}
